import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PLAID_PROCESSOR_TOKEN_BASE_PATH } from '../../../../../../../../../features/vendor/plaid/processor-token/plaid-processor-token-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'plaid-processor-token-list',
        label: 'Plaid',
        to: PLAID_PROCESSOR_TOKEN_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
